// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nh-3";
export var downloadButton = "_nh-4";
export var fileContainer = "_nh-9 _nh-7";
export var fileContainerBase = "_nh-7";
export var fileContainerFixedHeight = "_nh-8 _nh-7";
export var fileInfo = "_nh-5";
export var fileInfoWidthRestricted = "_nh-6";
export var fileType = "_nh-1";
export var fileTypeName = "_nh-2";
export var image = "_nh-0";
export var link = "_nh-b";
export var overflowEllipsis = "_nh-a";